var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2137_7269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3511 8.13086H3.35107",
    stroke: "#ACAFB9",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85107 3.63086L3.35107 8.13086L7.85107 12.6309",
    stroke: "#ACAFB9",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2137_7269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.851074 0.130859)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftLight);
export default __webpack_public_path__ + "static/media/arrow_left_light.936b8e149d815301d4a282f5e18e1191.svg";
export { ForwardRef as ReactComponent };